import { faHeart as faHeartRegular } from "@fortawesome/pro-regular-svg-icons";
import { faHeart } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const HeartIcon = styled(FontAwesomeIcon)({
  width: 20,
  height: 20,
  fontSize: 18,
});

type LikeIconProps = {
  isLiked: boolean;
};

export default function LikeIcon({ isLiked }: LikeIconProps) {
  const icon = isLiked ? faHeart : faHeartRegular;
  return (
    <Box
      sx={{
        borderRadius: "50%",
        cursor: "pointer",
        color: "error.main",
        "&:hover": { color: "error.dark" },
      }}
    >
      <HeartIcon icon={icon} />
    </Box>
  );
}
